import React from "react";
import { useTranslation } from "react-i18next";

export default function Res(): JSX.Element {
    const { t } = useTranslation("assessment");
    return (
        <>
            <h3>{t("res.title") as string}</h3>
            <p>{t("res.paragraph-1") as string}</p>
            <p>{t("res.list-title") as string}</p>
            <ol>
                <li>{t("res.list.point-1") as string}</li>
                <li>{t("res.list.point-2") as string}</li>
                <li>{t("res.list.point-3") as string}</li>
                <li>{t("res.list.point-4") as string}</li>
                <li>{t("res.list.point-5") as string}</li>
            </ol>
            <p>{t("res.paragraph-2") as string}</p>
            <p>{t("res.paragraph-3") as string}</p>
            <p>{t("res.paragraph-4") as string}<a className="bolder-text" href={t("res.hyperlink") as string} target='_blank' rel="noopener noreferrer">{t("res.hyperlink-text") as string}</a>.</p>
        </>
    );
}